import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {
  Accordion, AccordionDetails, AccordionSummary, Box, Typography,
} from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import usePrevious from '../../../../../../../Hooks/usePrevious';
import { SessionComplianceChecklistItem } from '../../../../../../LiveContext/Hooks/useSession/useSessionCompliance/type';
import StyledBox from './styles';
import RichTextRenderer from '../../../../../../../Common/RichTextRenderer';
import CommandChecklist from './Components/CommandChecklist';

export default function ComplianceChecklistItem(props: { item: SessionComplianceChecklistItem }) {
  const { item } = props;
  const [open, setOpen] = React.useState(!item.isCompleted);
  const previousComplete = usePrevious(item.isCompleted);
  const { t } = useTranslation();
  React.useEffect(() => {
    if (!previousComplete && item.isCompleted) {
      setOpen(false);
    }
  }, [item.isCompleted, previousComplete]);
  return (
    <StyledBox color={item.topic.color}>
      <Accordion expanded={open} onChange={(_e, value) => { setOpen(value); }} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-${item.topic.text}-content`}
          id={`panel-${item.topic.text}-header`}
          className={clsx({ completed: item.isCompleted })}
        >
          {item.isCompleted ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
          <Typography variant="subtitle1">
            {item.topic.text}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          id={`panel-${item.topic.text}-content`}
        >
          {item.complianceExample && (
            <Box>
              <Typography variant="subtitle2">
                {t('home-page.compliance.mandatory.instructions')}
              </Typography>
              <RichTextRenderer value={item.complianceExample} />
            </Box>
          )}
          {(item.topic.projectCommands?.items.length ?? 0) > 0 && (
            <CommandChecklist topic={item} />
          )}
        </AccordionDetails>
      </Accordion>
    </StyledBox>
  );
}
